<!-- 团队活动 -->
<template>
  <div class="team">
    <p>公司团队活动</p>
    <img src="https://cdn.welove520.com/static/res/vue/playbay/team.png">
    <p>组织聚餐&团队春游</p>
  </div>
</template>

<script>
export default {
  name: "Team",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("initTabName", "about");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.team {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 80px auto 90px auto;
}

.team > img {
  margin-top: 40px;
  margin-bottom: 15px;
  width: 400px;
}

.team > p:nth-child(1) {
  font-size: 20px;
  color: #e1556d;
}

.team > p:nth-child(2) {
  font-size: 18px;
  color: #303032;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue